import React, { ReactElement, useContext } from 'react';
import AddQuestion from './AddQuestion';
import Question from './Question';
import { FormsContext } from '../../context/FormsContext';
import DefaultFields from './DefaultFields';

const FormsDrafting = (): ReactElement => {
  const { questions } = useContext(FormsContext);

  const renderQuestions = (): ReactElement | ReactElement[] => {
    const lastIndex = questions.length - 1;
    if (questions.length === 0) {
      return <div></div>;
    } else {
      return questions.map((question, index) => {
        return (
          <div key={`render_questions_drafting_${index}`}>
            <Question lastIndex={lastIndex} question={{ ...question, index }} />
            <AddQuestion addingIndex={index + 1} />
          </div>
        );
      });
    }
  };

  return (
    <>
      <DefaultFields />
      <AddQuestion addingIndex={0} />
      {renderQuestions()}
    </>
  );
};

export default FormsDrafting;
